module.exports = __webpack_public_path__ + "img/error_icon.3085384a.svg";